import React from 'react';
import Card from './Card';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  todayValue?: string | number;
  change?: number;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  showToday?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  todayValue,
  change,
  color = 'primary',
  showToday = true,
}) => {
  const colorClasses = {
    primary: 'text-primary-500',
    secondary: 'text-secondary-500',
    success: 'text-green-500',
    warning: 'text-yellow-500',
    danger: 'text-red-500',
  };

  const iconBg = {
    primary: 'rgba(212, 160, 23, 0.1)',
    secondary: 'rgba(109, 109, 109, 0.1)',
    success: 'rgba(16, 185, 129, 0.1)',
    warning: 'rgba(245, 158, 11, 0.1)',
    danger: 'rgba(239, 68, 68, 0.1)',
  };

  const shouldShowSecondValue = showToday && todayValue !== undefined;

  return (
    <Card padding="sm">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs text-gray-500 font-medium">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>

          {shouldShowSecondValue && (
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-gray-500">Today:</span>
              <span className="text-xs font-semibold text-secondary-600">{todayValue}</span>
            </div>
          )}

          {change !== undefined && (
            <div className="flex items-center gap-1.5 mt-1">
              <span
                className={`inline-flex items-center text-xs font-medium ${
                  change >= 0 ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {change >= 0 ? '↑' : '↓'} {Math.abs(change)}%
              </span>
              <span className="text-[10px] text-gray-400">from last month</span>
            </div>
          )}
        </div>
        <div
          className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${colorClasses[color]}`}
          style={{ backgroundColor: iconBg[color] }}
        >
          {icon}
        </div>
      </div>
    </Card>
  );
};

export default StatsCard;